/** @format */

const CategoriaServiziTranslations = {
  en: {
    'Categoria2Livello.title': 'Aesthetic enhancement',
    'Categoria2Livello.description': "It's never late to take care of yourself.",
    'Categoria2Livello.description1':
      "Home care services for enhancing the person's aesthetic potential.",
    'Categoria2Livello.card': "Men's hairdresser",
    'Categoria2Livello.card1': 'Aesthetic manicure',
    'Categoria2Livello.card2': 'Aesthetic pedicure',
    'Categoria2Livello.card3': 'Hairdresser Woman',
  },
  it: {
    'Categoria2Livello.title': 'Valorizzazione estetica',
    'Categoria2Livello.description': 'Non è mai tardi per prendersi cura di se stessi.',
    'Categoria2Livello.description1':
      'Servizi domiciliari per la valorizzazione della potenzialità estetiche della persona.',
    'Categoria2Livello.card': 'Parrucchiere Uomo',
    'Categoria2Livello.card1': 'Manicure Estetica',
    'Categoria2Livello.card2': 'Pedicure Estetica',
    'Categoria2Livello.card3': 'Parrucchiere Donna',
  },
};

export default CategoriaServiziTranslations;
